import { environmentHttpClient } from "client/Api/httpClient";

export const enum ApiKeyScopeKind {
	IntegrationCredentials = 1,
	Activity = 2,
	UserApps = 3,
	Announcements = 4,
	AppIcons = 5,
	Events = 6,
	KnowledgeItems = 7
}

export type ApiKeyGridItem = {
	id: number;
	isEnabled: boolean;
	name: string;
	generatedOn: string | undefined;
	scope: ApiKeyScopeKind[];
};

export type SaveApiKeyModel = {
	isEnabled: boolean;
	name: string;
	scope: ApiKeyScopeKind[];
};

export type CreateApiKeyResult = {
	item: ApiKeyGridItem;
	key: string;
};

export type EditApiKeyModel = {
	isEnabled: boolean;
	name: string;
	scope: ApiKeyScopeKind[];
};

export type RegenerateApiKeyResult = {
	key: string;
	generatedOn: string;
};

export function list(signal: AbortSignal): Promise<ApiKeyGridItem[]> {
	return environmentHttpClient.get<ApiKeyGridItem[]>(
		"UiApi/ApiKeys",
		null,
		{ signal }
	);
}

export function deleteMultiple(ids: number[]): Promise<void> {
	return environmentHttpClient.delete<void>(
		"UiApi/ApiKeys",
		ids
	);
}

export function create(model: SaveApiKeyModel): Promise<CreateApiKeyResult> {
	return environmentHttpClient.post<CreateApiKeyResult>(
		"UiApi/ApiKeys",
		model
	);
}

export function update(id: number, model: SaveApiKeyModel): Promise<ApiKeyGridItem> {
	return environmentHttpClient.put<ApiKeyGridItem>(
		`UiApi/ApiKeys/${id}`,
		model
	);
}

export function getForEditing(id: number, signal: AbortSignal): Promise<EditApiKeyModel> {
	return environmentHttpClient.get<EditApiKeyModel>(
		`UiApi/ApiKeys/${id}`,
		null,
		{ signal }
	);
}

export function regenerate(id: number): Promise<RegenerateApiKeyResult> {
	return environmentHttpClient.put<RegenerateApiKeyResult>(
		`UiApi/ApiKeys/${id}/Regenerate`
	);
}